import AuthModel from './AuthModel'
import axios from 'axios'
import config from 'react-observable-store'

/**
 * Programs model
 *
 * Responsible to comunicate with remote server
 * @type {String}
 */
const ProgramsModel = {

    /**
     * Server endpoint
     * @type {String}
     */
     endpoint: () => {
         return config.get('globals').server.endpoint + '/programs'
     },

    /**
     * Get HTTP options
     * @return {object}
     */
    getOptions: () => {
        return {
            headers: {
                'X-Authorization': AuthModel.getAuthToken()
            }
        }
    },

    /**
     * Dispense a new record
     * @return {object} The new record as object
     */
    dispense: () => {
        return {
            id: "",
            titulo: "",
            descricao: "",
            url: "",
            data_inicio: "",
            data_fim: "",
            address: "",
            center: [-890098.6486544819, 4802796.404035872],
            zoom: 6,
            locals: []
        }
    },

    /**
     * Find all records
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findAll: (cb) => {
        return axios.get(ProgramsModel.endpoint(), ProgramsModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            } else {
                cb([]);
            }
        })
        .catch((error) => {
            cb([]);
        });
    },

    /**
     * Find all active records
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    findAllActive: (cb) => {
        return axios.get(ProgramsModel.endpoint() + 'public', ProgramsModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            } else {
                cb([]);
            }
        })
        .catch((error) => {
            cb([]);
        });
    },

    /**
     * Find record
     * @param  {Function} cb Async return
     * @return {[type]}      [description]
     */
    find: (id, cb) => {
        return axios.get(ProgramsModel.endpoint() + '/' + id, ProgramsModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            } else {
                cb({});
            }
        })
        .catch((error) => {
            cb({});
        });
    },

    /**
     * Store record
     * @param  {object}   item The record to store
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    store: (item, cb) => {
        axios.post(ProgramsModel.endpoint(), item, ProgramsModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                cb(res.data);
            }
        });
    },

    /**
     * Remove record
     * @param  {object}   item The record to be removed
     * @param  {Function} cb   Async return
     * @return {[type]}        [description]
     */
    remove: (item, cb) => {
        axios.delete(ProgramsModel.endpoint() + '/' + item.id, ProgramsModel.getOptions())
        .then(res => {
            if (res.status === 200) {
                cb();
            }
        });
    },

    /**
     * Generate new id
     * @return {number} The new id
     */
    generateId: () => {
        return Math.floor(Math.random() * 1000000) + 1
    }
}

export default ProgramsModel



// WEBPACK FOOTER //
// ./src/models/ProgramsModel.js